import { render, staticRenderFns } from "./VentanaModificarUsuario.vue?vue&type=template&id=6d1e2920&scoped=true&slot-scope=scope&"
import script from "./VentanaModificarUsuario.vue?vue&type=script&lang=js&"
export * from "./VentanaModificarUsuario.vue?vue&type=script&lang=js&"
import style0 from "./VentanaModificarUsuario.vue?vue&type=style&index=0&id=6d1e2920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1e2920",
  null
  
)

export default component.exports